"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = watchReviews;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _humps = require("humps");

var _effects = require("redux-saga/effects");

var _utils = require("@dom/utils");

var _types = require("../actions/types");

var _reviews = require("../actions/reviews");

var _utils2 = require("../utils");

var _marked =
/*#__PURE__*/
_regenerator["default"].mark(watchReviews),
    _marked2 =
/*#__PURE__*/
_regenerator["default"].mark(fetchReviews),
    _marked3 =
/*#__PURE__*/
_regenerator["default"].mark(addReview),
    _marked4 =
/*#__PURE__*/
_regenerator["default"].mark(addReply),
    _marked5 =
/*#__PURE__*/
_regenerator["default"].mark(deleteReview),
    _marked6 =
/*#__PURE__*/
_regenerator["default"].mark(deleteReply);

function watchReviews() {
  return _regenerator["default"].wrap(function watchReviews$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.all)([(0, _effects.takeLatest)(_types.FETCH_REVIEWS, fetchReviews), (0, _effects.takeLatest)(_types.ADD_REVIEW, addReview), (0, _effects.takeLatest)(_types.ADD_REPLY, addReply), (0, _effects.takeLatest)(_types.DELETE_REVIEW, deleteReview), (0, _effects.takeLatest)(_types.DELETE_REPLY, deleteReply)]);

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function fetchReviews(_ref) {
  var origin, url, _ref2, data;

  return _regenerator["default"].wrap(function fetchReviews$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          origin = _ref.origin;
          _context2.prev = 1;
          url = _utils.endpoints[origin].reviews(id[origin]());
          _context2.next = 5;
          return (0, _effects.call)(_utils.api.get, url);

        case 5:
          _ref2 = _context2.sent;
          data = _ref2.data;
          _context2.next = 9;
          return (0, _effects.put)((0, _reviews.storeReviews)((0, _humps.camelizeKeys)(data.comments)));

        case 9:
          _context2.next = 14;
          break;

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](1);
          console.log(_context2.t0);

        case 14:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[1, 11]]);
}

function addReview(_ref3) {
  var review, origin, userInfo, _url, _ref4, user, _data, response, token, rest, _response;

  return _regenerator["default"].wrap(function addReview$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          review = _ref3.review, origin = _ref3.origin, userInfo = _ref3.userInfo;
          _context3.prev = 1;
          _url = _utils.endpoints[origin].reviews(id[origin]());
          _context3.next = 5;
          return (0, _effects.select)();

        case 5:
          _ref4 = _context3.sent;
          user = _ref4.user;
          _data = null;

          if (!user.userId) {
            _context3.next = 15;
            break;
          }

          _context3.next = 11;
          return (0, _effects.call)(_utils.api.post, _url, {
            comment: review
          });

        case 11:
          response = _context3.sent;
          _data = response.data;
          _context3.next = 20;
          break;

        case 15:
          // for guest login
          token = userInfo.token, rest = (0, _objectWithoutProperties2["default"])(userInfo, ["token"]);
          _context3.next = 18;
          return (0, _effects.call)(_utils.api.postAsAGuest, _url, (0, _objectSpread2["default"])({
            comment: review
          }, rest), token);

        case 18:
          _response = _context3.sent;
          _data = _response.data;

        case 20:
          _context3.next = 22;
          return (0, _effects.put)((0, _reviews.updateReview)((0, _humps.camelizeKeys)(_data.comments)));

        case 22:
          _context3.next = 27;
          break;

        case 24:
          _context3.prev = 24;
          _context3.t0 = _context3["catch"](1);
          console.log(_context3.t0);

        case 27:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[1, 24]]);
}

function addReply(_ref5) {
  var reviewId, review, origin, _url2, _ref6, _data2;

  return _regenerator["default"].wrap(function addReply$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          reviewId = _ref5.reviewId, review = _ref5.review, origin = _ref5.origin;
          _context4.prev = 1;
          _url2 = _utils.endpoints[origin].reply(id[origin](), reviewId);
          _context4.next = 5;
          return (0, _effects.call)(_utils.api.post, _url2, {
            comment: review
          });

        case 5:
          _ref6 = _context4.sent;
          _data2 = _ref6.data;
          _context4.next = 9;
          return (0, _effects.put)((0, _reviews.updateReply)((0, _humps.camelizeKeys)(_data2.comments)));

        case 9:
          _context4.next = 14;
          break;

        case 11:
          _context4.prev = 11;
          _context4.t0 = _context4["catch"](1);
          console.log(_context4.t0);

        case 14:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[1, 11]]);
}

function deleteReview(_ref7) {
  var reviewId, origin, _url3, _ref8, _data3;

  return _regenerator["default"].wrap(function deleteReview$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          reviewId = _ref7.reviewId, origin = _ref7.origin;
          _context5.prev = 1;
          _url3 = _utils.endpoints[origin].reviews(id[origin]());
          _context5.next = 5;
          return (0, _effects.call)(_utils.api["delete"], _url3, reviewId);

        case 5:
          _ref8 = _context5.sent;
          _data3 = _ref8.data;
          _context5.next = 9;
          return (0, _effects.put)((0, _reviews.updateReview)((0, _humps.camelizeKeys)(_data3.comments)));

        case 9:
          _context5.next = 14;
          break;

        case 11:
          _context5.prev = 11;
          _context5.t0 = _context5["catch"](1);
          console.log(_context5.t0);

        case 14:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5, null, [[1, 11]]);
}

function deleteReply(_ref9) {
  var replyId, origin, _url4, _ref10, _data4;

  return _regenerator["default"].wrap(function deleteReply$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          replyId = _ref9.replyId, origin = _ref9.origin;
          _context6.prev = 1;
          _url4 = _utils.endpoints[origin].reply(id[origin](), replyId);
          _context6.next = 5;
          return (0, _effects.call)(_utils.api["delete"], _url4);

        case 5:
          _ref10 = _context6.sent;
          _data4 = _ref10.data;
          _context6.next = 9;
          return (0, _effects.put)((0, _reviews.updateReply)((0, _humps.camelizeKeys)(_data4.comments)));

        case 9:
          _context6.next = 14;
          break;

        case 11:
          _context6.prev = 11;
          _context6.t0 = _context6["catch"](1);
          console.log(_context6.t0);

        case 14:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6, null, [[1, 11]]);
}

var id = {
  treks: _utils2.getTrekIdFromUrl,
  lodge: _utils2.getLodgeIdFromUrl,
  profile: _utils2.getUserIdFromUrl,
  flights: function flights() {
    return 'f8016c413194';
  }
};